import { render, staticRenderFns } from "./CardTicketSingleTrip.vue?vue&type=template&id=7c625232&scoped=true&"
import script from "./CardTicketSingleTrip.vue?vue&type=script&lang=js&"
export * from "./CardTicketSingleTrip.vue?vue&type=script&lang=js&"
import style0 from "./CardTicketSingleTrip.vue?vue&type=style&index=0&id=7c625232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c625232",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol})
